<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full p-4 pl-6">
            <!-- Logo -->
            <div class="flex items-center justify-center"></div>
        </div>
    </ng-container>
    <!-- Navigation footer hook
    <ng-container fuseVerticalNavigationContentFooter>
        <div class="flex flex-0 items-center justify-center h-16 pr-6 pl-2 mt-2 mb-4 opacity-12">
            <img
                class="max-w-36"
                src="assets/images/logo/logo-text-on-dark.svg">
        </div>
    </ng-container>-->
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-20 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card bg-green dark:bg-transparent print:hidden"
    >
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon
                class="mat-icon-color"
                [svgIcon]="'heroicons_outline:home'"
            ></mat-icon>
        </button>
        <!-- Components -->
        <div class="flex items-center justify-between w-full p-0">
            <div>
                <div class="text-xl font-bold tracking-tight leading-8">
                    {{ currentPage }}
                </div>
                <div class="font-medium tracking-tight text-secondary"></div>
            </div>
        </div>
        <div
            class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2 text-black"
        >
            <!-- <languages></languages> -->
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>

            <div
                class="grid xs:grid-cols-6 sm:grid-cols-3 md:grid-cols-3 gap-1 justify-items-start"
            >
                <!-- Dark/Light Mode Toggle -->
                <div
                    class="flex items-center py-2 xs:px-1 sm:pl-5 sm:pr-6 rounded-full cursor-pointer ring-inset ring-primary bg-hover"
                    [class.ring-2]="config.scheme === 'dark'"
                    (click)="toggleScheme()"
                >
                    <div class="flex items-center rounded-full overflow-hidden">
                        <mat-icon
                            class="icon-size-5"
                            [ngClass]="{
                                'mat-icon-color': config.scheme !== 'dark'
                            }"
                            [svgIcon]="
                                config.scheme === 'dark'
                                    ? 'heroicons_solid:sun'
                                    : 'heroicons_solid:moon'
                            "
                        ></mat-icon>
                    </div>
                    <div
                        class="flex items-center xs:ml-1 md:ml-2 sm:font-small md:font-medium leading-5"
                        [class.text-secondary]="config.scheme !== 'dark'"
                    >
                        {{ config.scheme === "dark" ? "Light" : "Dark" }}
                    </div>
                </div>
                <div class="flex items-center py-2 xs:px-1 sm:pl-5 sm:pr-6 rounded-full cursor-pointer ring-inset ring-primary bg-hover">
                    <button mat-menu-item>
                        <mat-icon
                            svgIcon="live_tv"
                            [ngClass]="{ 'mat-icon-color': config.scheme !== 'dark' }"
                        ></mat-icon>
                    </button>
                </div>
                <div class="flex items-center py-2 xs:px-1 sm:pl-5 sm:pr-6 rounded-full cursor-pointer ring-inset ring-primary bg-hover">
                    <button
                        mat-menu-item
                        matTooltip="Sign out"
                        (click)="signOut()"
                    >
                        <mat-icon
                            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
                            [ngClass]="{ 'mat-icon-color': config.scheme !== 'dark' }"
                        ></mat-icon>
                        <span class="hidden sm:inline ml-2">Sign out</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>-->
</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
